import BaseModel from "../default/base-model";
import {Bom} from "./bom";
import {Component} from "./component";

export class BomComponent extends BaseModel {
    static UsagePriority : {
        PRIMARY : 1,
        ALTERNATIVE : 2,
    };

    static MType = {
        ZHLB: "ZHLB",
        ZMOD: "ZMOD",
        ZROH: "ZROH"
    };


    is_phantom?: boolean;
    is_imperfect?: boolean;
    bom?: Bom;
    item?: number;
    group?: string;
    consumption_priority?: number;
    purchase_priority?: number;
    component?: Component;
    quantity?: number;
    mtype?: string;

    children_components?: Array<BomComponent>;
    parent_component?: number;
}
